import { IObserver } from '@/taskpane/common/observer-pattern'
import office from '@/taskpane/officejs/office-wrapper'
import broadcastMessageToPortals from '../messages/broadcast-message-to-portals'
import ItemChangeArgs from '../messages/item-change-args'
import OfficeObservable from './office-observable'
import { sendMessageToSidebarWithIdsAfterComposeChanges } from '../messages/send-message-to-sidebar-with-ids-after-compose-check'

export class SubjectObservable extends OfficeObservable<string> {
  public eventHandlerType = () => null
  public get = async () => office.subject.get()
}

export default class SubjectObserver implements IObserver<string> {
  public async update(subject: string): Promise<void> {
    if (office.mode.isMessage()) {
      await office.save()
      const people = office.people.get()
      const args: ItemChangeArgs = {
        data: subject,
        type: 'subject',
      }
      sendMessageToSidebarWithIdsAfterComposeChanges('MailItemDataChange', args, subject, people)
    } else if (office.mode.isAppointment()) {
      const args: ItemChangeArgs = {
        data: subject,
        type: 'title',
      }
      broadcastMessageToPortals('EventItemDataChange', args)
    }
  }
}
